import { createFileRoute } from "@tanstack/react-router";
import { BoardPage } from "@/pages/board.page";

export const Route = createFileRoute("/_auth/boards/$slug")({
  component: BoardPage,
});
